/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type consultAnExpert_viewer$ref = any;
export type consultAnExpert_viewer = {
    readonly isConsultAnExpertDisabled: boolean | null;
    readonly " $refType": consultAnExpert_viewer$ref;
};



const node: ReaderFragment = ({
    "kind": "Fragment",
    "name": "consultAnExpert_viewer",
    "type": "Viewer",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": [
        {
            "kind": "ScalarField",
            "alias": "isConsultAnExpertDisabled",
            "name": "isEnabledByLocale",
            "args": [
                {
                    "kind": "Literal",
                    "name": "featureName",
                    "value": "DISABLE_CONSULT_AN_EXPERT"
                }
            ],
            "storageKey": "isEnabledByLocale(featureName:\"DISABLE_CONSULT_AN_EXPERT\")"
        }
    ]
} as any);
(node as any).hash = 'ce3292977b99c58ac6db4bda3ebc027b';
export default node;
